import { useEffect, useState } from "react";

export function useAsyncData<T>(fetcher: () => Promise<T>): {
	data: T | null;
	loading: boolean;
	error: string | null;
} {
	const [data, setData] = useState<T | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		let cancelled = false;

		const load = async () => {
			try {
				const result = await fetcher();
				if (!cancelled) setData(result);
			} catch {
				if (!cancelled) setError("Failed to load data.");
			} finally {
				if (!cancelled) setLoading(false);
			}
		};

		load();

		return () => {
			cancelled = true;
		};
	}, [fetcher]);

	return { data, loading, error };
}
